import { FormControl } from '@angular/forms';
import { createTemplateValidator } from './forms.validators';

/**
 * A capability's prompt.
 *
 * `dirty` compares against the text the control was loaded with, so a prompt typed and then undone is not sent —
 * which matters because a stated prompt on a global or managed capability forks it into the local namespace.
 * Angular's own pristine flag above this control still trips on the first keystroke and never recovers.
 */
export class AiPromptControl extends FormControl<string> {
  private originalContent: string;

  constructor(content = '') {
    super(content, { nonNullable: true, asyncValidators: [createTemplateValidator()] });
    this.originalContent = content;
  }

  override get dirty(): boolean {
    return this.getRawValue() !== this.originalContent;
  }

  override markAsPristine(opts?: { onlySelf?: boolean; emitEvent?: boolean }): void {
    super.markAsPristine(opts);
    this.originalContent = this.getRawValue();
  }
}
